<template functional>
  <v-hover
    :key="`${props.value.id}_${props.height}_${props.favoriteActionable}`"
    v-slot="{ hover }"
  >
    <app-card
      class="pa-4 no-focus d-flex flex-column"
      :color="props.backgroundColor"
      :height="props.height"
      :width="$options.width(props.height, props.bottomSize)"
      v-on="props.selectable ? { click: listeners['click']} : { click: listeners['click:image'] }"
    >
      <div
        class="absolute fill-height pa-0 ma-0 ma-n4 col rounded pa-2 cursor-pointer"
      >
        <div
          v-show="props.selected || (!props.selectable && hover)"
          class="fill-height col rounded app-card--reveal pa-0"
          :class="{ 'primary--text outlined' : props.selectable }"
        >
          <div class="inputBg rounded fill-height col pa-0 ma-0">
            
          </div>
        </div>

        <div
          v-show="hover && !props.selected && props.selectable"
          class="fill-height col rounded outlined secondary--text"
        >
        </div>

        <template v-if="hover">
          <div
            class="absolute z-1 top-0 col d-flex flex-column fill-height justify-center align-center"
          >
            <div class="d-flex flex-row justify-center align-center">
              <slot name="hover"></slot>
            </div>
          </div>
        </template>
      </div>

      <v-row
        class="relative z-1"
      >
        <v-col
          align="center"
          class="relative"
        >
          <!-- v-for below is a hack to set local var -->
          <v-btn
            v-for="status of [ $options.status(props.value.status) ]"
            :key="status.key"
            icon
            class="transparent no-focus no-hover"
            :height="$options.size(props.height, props.bottomSize)"
            :width="$options.size(props.height, props.bottomSize)"
          >
            <v-avatar
              class="cursor-pointer"
              :color="status !== $options.enums.Status.PUBLISHED ? status.color : 'transparent'"
              :size="$options.size(props.height, props.bottomSize)"
            >
              <v-avatar
                class="cursor-pointer"
                color="cardBg"
                :size="$options.sizeInner(props.height, props.bottomSize, status)"
              >
                <slot name="image">
                  <v-img
                    :src="$options.rendersAPI.getPreviewSrc(props.value.renders_order[0])"
                    eager
                    class="d-flex"
                  >
                    <v-row
                      v-show="status !== $options.enums.Status.PUBLISHED"
                      no-gutters
                      class=" fill-height"
                    >
                      <v-col
                        cols="6"
                        class="d-flex flex-column align-center relative status"
                      >
                        <div class="fill-height fill-width d-flex flex-column align-center overflow-hidden absolute z-1">
                          <div class="my-auto fill-width text-hyphens overflow-hidden">
                            {{ status.title }}
                          </div>
                        </div>

                        <app-card
                          class="absolute fill-height app-card--reveal rounded-0"
                          :color="status.color"
                          width="100%"
                        >
                        </app-card>
                      </v-col>
                    </v-row>

                    <div class="absolute z-1 top-0 col d-flex flex-column fill-height justify-center align-center">
                      <div class="d-flex flex-row justify-center align-center">
                        <slot name="avatar">
                        </slot>
                      </div>
                    </div>

                  </v-img>
                </slot>
              </v-avatar>
            </v-avatar>
          </v-btn>

          <template v-if="props.downloadable">
            <app-button
              v-if="hover"
              :loading="props.value.downloadLoading"
              :disabled="!props.value.packages.length"
              fab
              absolute
              bottom
              right
              small
              outlined
              no-tooltip
              main-icon="$vuetify.icons.download"
              class="ma-1 right-2 bottom-0"
              @click="listeners['click:download']"
            >
            </app-button>
          </template>

          <template v-if="props.favoriteActionable">
            <app-button
              v-if="hover"
              fab
              small
              absolute
              top
              right
              outlined
              no-tooltip
              :main-icon="props.value.favorite ? '$vuetify.icons.favoriteOn' : '$vuetify.icons.favoriteOff'"
              class="ma-1 top-0 right-2"
              :loading="props.value.loadingFavorite"
              @click="listeners['click:favorite']"
            >
            </app-button>
          </template>

          <slot name="hover" :hover="hover"></slot>

          <div
            v-if="$options.isNew(props.value)"
            class="absolute top-0 right-0 pr-2"
          >
            <v-chip
              color="primary"
              class="text-uppercase px-4"
              small
            >
              New
            </v-chip>
          </div>

        </v-col>
      </v-row>

      <div class="flex-grow-1"></div>

      <v-row
        class="mt-auto pt-2 relative z-1"
        justify="center"
        no-gutters
      >
        <v-col align="center">
          <div
            v-if="props.selectable"
            class="pb-2"
          >
            <app-card
              width="100%"
              class="mb-2 py-1 px-2 text-ellipsis rounded outlined white--border"
              color="secondary"
              @click="listeners['click:open']"
              @click.stop
            >
              <div class="flex-grow-0 flex-shrink-0 d-flex align-center justify-center">
                <span
                  style="padding-top: 2px"
                  class="text-ellipsis body-1 z-1">{{ props.value.title }}
                </span>
                <v-icon size="20" class="ml-2">
                  $vuetify.icons.linkto
                </v-icon>
              </div>

            </app-card>
          </div>

          <div
            v-else
            class="text-hyphens title mt-auto"
            style="line-height: 1;"
            :class="{ 'primary--text': hover }"
          >{{ props.value.title }}</div>
        </v-col>
      </v-row>

    </app-card>
  </v-hover>
</template>

<script>
  import enums from '@/enums';
  import materials from '@/utils/materials';
  import rendersAPI from '@/api/modules/renders';

  export default {
    name: 'MaterialCard',

    props: {
      backgroundColor: {
        type: String,
      },
      height: {
        type: Number,
        default: 200,
      },
      value: {
        type: Object,
      },
      bottomSize: {
        type: Number,
        default: 70,
      },
      selected: {
        type: Boolean,
        default: false,
      },
      selectable: {
        type: Boolean,
        default: true,
      },
      downloadable: {
        type: Boolean,
        default: true,
      },
      loadingFavorite: {
        type: Boolean,
        default: false,
      },
      favoriteActionable: {
        type: Boolean,
        default: false,
      },
    },

    isNew(material) {
      return materials.isNew(material);
    },

    width(height, bottomSize) {
      return height - bottomSize;
    },

    size(height, bottomSize) {
      return height - bottomSize - 32;
    },

    sizeInner(height, bottomSize, status) {
      let size = height - bottomSize - 32;
      if (status !== enums.Status.PUBLISHED) return size - 4;
      return size;
    },

    status(statusKey) {
      return enums.Status.getByKey(statusKey);
    },

    enums,
    rendersAPI,
  }
</script>